import { useMutation } from "@tanstack/react-query"
import type {
  UseMutationOptions,
  UseMutationResult,
} from "@tanstack/react-query"

import client from "~/backend/axiosClient"

import type {
  GenerateExportMutationRequest,
  GenerateExportMutationResponse,
} from "../types/GenerateExport"

type GenerateExportClient = typeof client<
  GenerateExportMutationResponse,
  Error,
  GenerateExportMutationRequest
>
type GenerateExport = {
  data: GenerateExportMutationResponse
  error: Error
  request: GenerateExportMutationRequest
  pathParams: never
  queryParams: never
  headerParams: never
  response: Awaited<ReturnType<GenerateExportClient>>
  client: {
    parameters: Partial<Parameters<GenerateExportClient>[0]>
    return: Awaited<ReturnType<GenerateExportClient>>
  }
}
/**
 * @summary Generate export
 * @link /v1/export/generate
 */
export function useGenerateExport(
  options: {
    mutation?: UseMutationOptions<
      GenerateExport["response"],
      GenerateExport["error"],
      GenerateExport["request"]
    >
    client?: GenerateExport["client"]["parameters"]
  } = {}
): UseMutationResult<
  GenerateExport["response"],
  GenerateExport["error"],
  GenerateExport["request"]
> {
  const { mutation: mutationOptions, client: clientOptions = {} } =
    options ?? {}
  return useMutation<
    GenerateExport["response"],
    GenerateExport["error"],
    GenerateExport["request"]
  >({
    mutationFn: async (data) => {
      const res = await client<
        GenerateExport["data"],
        GenerateExport["error"],
        GenerateExport["request"]
      >({
        method: "post",
        url: `/v1/export/generate`,
        data,
        ...clientOptions,
      })
      return res
    },
    ...mutationOptions,
  })
}
